/*************** */
/* CSS           */
/*************** */
import './assets/css/main.css'

/*************** */
/* Vue Directives   */
/*************** */
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
import sticky from './directives/sticky.js'
import autoScroll from './directives/auto-scroll.js'

/*************** */
/* Quasar        */
/*************** */
import { Quasar, Notify, Dialog, Loading } from 'quasar'
import quasarLang from 'quasar/lang/fr'

import '@quasar/extras/material-icons/material-icons.css'
import 'quasar/src/css/index.sass'
import '@tofandel/q-tel-input/dist/style.css' // quasar phone input

/*************** */
/* API           */
/*************** */
import { initAxiosRequestInterceptor } from './api/interceptors.js'

/*************** */
/* Vue app       */
/*************** */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

const app = createApp(App)

/*************** */
/* Sentry        */
/*************** */
import Sentry from './services/Sentry.js'

Sentry.init(app)

/******************** */
/* App dependencies   */
/******************** */
app.use(Quasar, {
  lang: quasarLang,
  plugins: {
    Notify,
    Dialog,
    Loading,
  },
})
app.use(autoAnimatePlugin)
app.use(createPinia())
app.use(router)
app.directive('sticky', sticky)
app.directive('auto-scroll', autoScroll)
app.mount('#app')

/*************** */
/* API           */
/*************** */
import Realtime from './api/realtime'

const $q = app.config.globalProperties.$q
initAxiosRequestInterceptor({ router, $q })

Realtime.connect()

/*************** */
/* Shepherd      */
/*************** */
import 'shepherd.js/dist/css/shepherd.css'
import './assets/css/tour.css'

window.process = { env: { NODE_ENV: import.meta.env.MODE } }
